/*
 * @Description:接口信息
 * @Author: kai.zhou
 * @Date: 2020-03-27 11:22:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-25 11:50:56
 */
import Axios from "tools/service";
import Axiosmd5 from "tools/servicemd5";
import md5 from "js-md5";
class WebApi {
  //获取图片--13---actor
  getBannerImg(params: any) {
    return Axios.get("/CarlcareClient/rp/header-image", {
      params: params,
    });
  }
  //获取国家列表--12---actor
  getCountries(params: any) {
    return Axios.get("/CarlcareClient/rp/country-list", {
      params: params,
    });
  }
  //获取国家机型--1---model
  getModels(params: any) {
    // return Axios.get("/CarlcareBg/spare-parts-price/brand-model-order", {
    // return Axios.get("/CarlcareBg/repair/getPartsParameterSinceV5632", {
    return Axios.get("/CarlcareBg/spare-parts-price/brand-model-series", {
      params: params,
    });
  }
  //部件价格列表查询--2---modelprice
  getFaults(params: any) {
    // return Axios.get("/CarlcareBg/spare-parts-price/parts-price", {
      return Axios.get("/CarlcareBg/repair/getPartsPrice", {
      params: params,
    });
  }
  //地理坐标获取周边店铺--15---shops
  getShopList(params: any) {
    return Axios.post("/CarlcareClient/rp/store-list-sorted", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  //获取店铺详情--4---shopdetails
  getShopDetails(params: any) {
    return Axios.post("/CarlcareClient/rp/store-info", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  //店铺评价列表--5---shopdetails
  getShopEvals(params: any) {
    return Axios.post("/CarlcareClient/rp/eval-list", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  //预约时间列表--6--order
  getTimes(params: any) {
    return Axios.post("/CarlcareClient/rp/appoint-date-time", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  //订单详情--7
  getOrderDetail(params: any, token: string) {
    return Axios.post("/CarlcareClient/rp/order-info", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Authorization": token,
      },
    });
  }
  //提交预约信息---8---order
  submit(params: any, keydata: any, token: string) {
    return Axios.post("/CarlcareClient/rp/order-submit", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        activity: params.exclusiveOrder ? "MAKE_MONEY2" : (params.makeMoney === false ? "CC-MANOR-BD" : ""),//makemoney活动名
        mcc: params.exclusiveOrder && params.makeMoney !== false ? 0 : '',//makemoney活动名
        share_mcc: params.makeMoney === false || params.source === "H5_farm_bd" ? '470' : '',
        "Authorization": token,
        // 加密模块
        key: keydata.key,
        secret: keydata.secret,
        token: keydata.token,
        timestamp: keydata.timestamp,
        sign: keydata.sign,
      },
    });
  }

  //提交寄修信息---印尼专用
  delisubmit(params: any, keydata: any, token: string) {
    return Axios.post("/CarlcareClient/express-indonesia/h5-order-submit", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        activity: params.exclusiveOrder ? "MAKE_MONEY2" : (params.makeMoney === false ? "CC-MANOR-BD" : ""),//makemoney活动名
        mcc: params.exclusiveOrder && params.makeMoney !== false ? 0 : '',//makemoney活动名
        share_mcc: params.makeMoney === false || params.source === "H5_farm_bd" ? '470' : '',
        "Authorization": token,
        // 加密模块
        key: keydata.key,
        secret: keydata.secret,
        token: keydata.token,
        timestamp: keydata.timestamp,
        sign: keydata.sign,
      },
    });
  }
  // 获取城市接口
  getCity(params: any) {
    return Axios.post("/CarlcareClient/rp/list-city", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }

  // 寄售维修类型接口
  deliveryFault(params: any) {
    return Axios.post("/CarlcareClient/home-maintenance/list-delivery-fault", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }

  // 上门维修省份列表
  deliveryProvince(params: any) {
    return Axios.post("/CarlcareClient/shop-list/delivery-province", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  // 上门维修城市列表
  deliveryCity(params: any) {
    return Axios.post("/CarlcareClient/shop-list/delivery-city", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  // 上门维修省份查询店铺列表
  deliveryShop(params: any) {
    return Axios.post("/CarlcareClient/shop-list/delivery-service-shop", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  // sms短信相关
  firstAsk(params: any) { return Axios.get("/CarlcareClient/sms/get-code", { params: params, }); }
  // 发送校验码 
  sendCode(params: any, token: string, sign: string, time: string) {
    return Axios.post("/CarlcareClient/sms/check-code", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        token,
        sign: md5(sign),
        time
      },
    });
  }

  //查看订单物流状态
  wuliustate(params: any) {
    return Axios.get("/CarlcareClient/express-indonesia/h5-express-pod-history", {
      params: params,
    });
  }
  //查看订单物流状态
  smartwuliustate(params: any) {
    return Axios.post("/CarlcareClient/express-indonesia/order-info",params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  //订单取消，会取消【预约单】和【物流单】
  cancelwuliu(params: any) {
    return Axios.get("/CarlcareClient/express-indonesia/h5-order-cancel", {
      params: params,
    });
  }
  // H5查询订单列表
  wuliulist(params: any) {
    return Axios.get("/CarlcareClient/express-indonesia/h5-order-list", {
      params: params,
    });
  }
  // H5查询订单列表使用前的vcode
  wuliulistVcode(params: any) {
    return Axios.get("/CarlcareManager/authority/get-verification-code", {
      params: params,
    });
  }
  // H5查询订单详情的物流信息
  wuliucnote(params: any) {
    return Axios.get("/CarlcareClient/express-indonesia/express-pod-history-original", {
      params: params,
    });
  }
  // 免费清洗下单店铺---,2308清洗券 2310免费券 
  getFreeShopList(params: any, activity: string ,mcc: any = 0) {
    return Axios.get("/CarlcareClient/draw-activity/store-list", {
      params: params,
      headers: {
        appCode: 2040,
        mcc: mcc,
        activity: activity || "LUCK_DRAW_2308"
      },
    });
  }
  // 免费清洗下单----------有token免加密
  freeSubmit(params: any, token: string, activity: string, mcc: any = 0) {
    return Axios.post("/CarlcareClient/draw-activity/order-submit", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Authorization": token,
        appCode: 2040,
        mcc: mcc,//写死
        activity: activity || "LUCK_DRAW_2308"
      },
    });
  }
  // 下单前接口
  getkey(params: any) {
    return Axiosmd5.get("/CarlcareClient/rp/get-key", {
      params: params,
    });
  }
  // 取消订单
  async cancelOrder(params: any) {
    return Axios.post("/CarlcareClient/rp/order-cancel-h5", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        'Accept': 'application/json',
        "appCode": "2040",
        'Authorization': '',
      },
    });
  }
  //获取是否支持上门维修---actor
  getgohomeservice(params: any) {
    let lang=(navigator.languages && navigator.languages[0]) || navigator.language;
    let langUse=lang.split("-")[0].toLowerCase();
    if (lang.split("-")[0].toLowerCase() === "zh") {
      if (lang.toLowerCase().indexOf('tw') > -1) {
        langUse = "zh_TW";
      } else {
        langUse = 'zh_CN'
      }
    }else if(lang.split("-")[0].toLowerCase() === "id"){
      langUse='in'
    }
    // type 1上门2智能柜
    return Axios.post("/CarlcareClient/shop-list/gohome-have", {country:params.country,types:[1,2]}, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        'Accept': 'application/json',
        "appCode": "2040",
        'Authorization': '',
        language:langUse,
        mcc:params.country
      },
    });
  }
  //获取上门省份列表---actor
  getgohomeservicelist(params: any) {
    let lang=(navigator.languages && navigator.languages[0]) || navigator.language;
    let langUse=lang.split("-")[0].toLowerCase();
    if (lang.split("-")[0].toLowerCase() === "zh") {
      if (lang.toLowerCase().indexOf('tw') > -1) {
        langUse = "zh_TW";
      } else {
        langUse = 'zh_CN'
      }
    }else if(lang.split("-")[0].toLowerCase() === "id"){
      langUse='in'
    }
    return Axios.post("/CarlcareClient/shop-list/gohome-province?type="+params.type, params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        'Accept': 'application/json',
        "appCode": "2040",
        'Authorization': '',
        language:langUse,
        mcc:params.country
      },
    });
  }
  //上门维修店铺列表
  getonsiteShopList(params: any) {
    return Axios.post("/CarlcareClient/shop-list/gohome-service-shop", params, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    });
  }
  //经纬度
  lalg() {
    let sign=md5('0.00.0H5carlcareloc');
    return Axios.get("/CarlcareClient/country/info-by-loc", {
      params: {source:'H5'},
      headers: {
        "sign": sign,
      },
    });
  }
  // 订单号加密
  getmd5number(params: any) {
    return Axios.get("/CarlcareClient/encry", {
      params: params,
    });
  }
  // 手机号解密
  slovemd5number(params: any) {
    return Axios.get("/CarlcareClient/decry", {
      params: params,
    });
  }
}
export default new WebApi();
